import { ADDITIONAL_SEATS_SKUS } from '../constants'
import { ICartItem, ICartItemUI, IPartialCartItem, IPrice, IProductFromApi } from '../interface'

export const getDietQuestion = (selectedProduct: IProductFromApi, selectedItem: number) => {
  const bizzaboDietQuestionFromApi = selectedProduct.items[selectedItem]?.bizzaboSession?.[0].questions?.find(
    (questions) => questions.name.includes('diet')
  )
  if (bizzaboDietQuestionFromApi?.name) {
    return {
      question: bizzaboDietQuestionFromApi!.label,
      answers: bizzaboDietQuestionFromApi!.values,
      selectedAnswer: ''
    }
  }
  return undefined
}

export const getAgeQuestion = (selectedProduct: IProductFromApi, selectedItem: number) => {
  const bizzaboAgeQuestionFromApi = selectedProduct.items[selectedItem]?.bizzaboSession?.[0].questions?.find(
    (questions) => questions.name.includes('age')
  )

  if (bizzaboAgeQuestionFromApi?.name) {
    return {
      question: bizzaboAgeQuestionFromApi!.label,
      answers: bizzaboAgeQuestionFromApi!.values,
      selectedAnswer: ''
    }
  }
  return undefined
}

// Sorts cartItems to make sure that the additional seats item is placed after the original product
// It is used after making a request to cart because the backend sends it in a random order
export const sortItemsForBizzabo = (products: ICartItemUI[]) => {
  const sortedProducts = products.sort((a, b) => {
    if (a.bizzaboSessionId && b.bizzaboSessionId) {
      if (a.bizzaboSessionId !== b.bizzaboSessionId) {
        return a.bizzaboSessionId.localeCompare(b.bizzaboSessionId)
      }

      const aIsAdditionalSeat = isAdditionalSeat(a)
      const bIsAdditionalSeat = isAdditionalSeat(b)

      if (!aIsAdditionalSeat && bIsAdditionalSeat) {
        return -1
      } else if (aIsAdditionalSeat && !bIsAdditionalSeat) {
        return 1
      }
    }
    return 0
  })
  return sortedProducts
}

/**
 * Remove additional seats from the main product when the additional seats are removed
 */
export const removeAdditionalSeats = (cart: ICartItem[], element: ICartItem) => {
  if (!isAdditionalSeat(element)) return
  // Target the main product related with the additional seat
  const cartItemToUpdate = cart.find(
    (cartItem) => cartItem.bizzaboSessionId === element.bizzaboSessionId && !isAdditionalSeat(cartItem)
  )
  // Reset additional seats from the main product
  if (cartItemToUpdate) cartItemToUpdate.bizzaboAdditionalSeatsToAdd = 0
}

/**
 * Checks if the cartItem is an additional seat by his sku
 */
export const isAdditionalSeat = (element: ICartItem | IPartialCartItem) =>
  ADDITIONAL_SEATS_SKUS.includes(element.productId)

export const hasAdditionalSeat = (priceElement: IPrice) => !!priceElement.metadata._additionalSeat

export const isBizzaboProduct = (productElement: IProductFromApi) => !!productElement.metadata._bizzaboEventId
